import React, { Component } from 'react'
import OneLineEditor from '../components/OneLineEditor'
import EstimationActions from '../libs/EstimationActions'
import Utils from '../libs/Utils'

class MaterialCostPrintTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation()
    }
  }
  materiaKingaku (data, category) {
    if (category.code === 'Mokuzai') {
      return data.suuryou * data.materialMokuzaiUnitPrice
    } else if (category.code === 'Shoumouhin') {
      return data.suuryou * data.materialShoumouhinUnitPrice
    } else if (category.code === 'Kouseizai') {
      return data.suuryou * data.materialKouseizaiUnitPrice
    }
  }
  renderDetailTable (list, start, end, category, tableOffset, katawakuSuuryou, goukei, isPrintGoukei) {
    const inputStyle = {
      backgroundColor: 'FFFFFF',
      cursor: 'normal'
    }
    const tableTitle = (start === 0) ? <p className='kw-pad1 kw-clear'><br />{category.name}</p> : ''
    const viewListId = 'uchiwake' + category.code + 'List'
    const unitPriceName = 'material' + category.code + 'UnitPrice'
    const noteName = 'meterial' + category.code + 'Note'
    const goukeiTr = isPrintGoukei ? (
      <tr>
        <td className='kw-top-double'>小計</td>
        <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='kw-top-double kw-ln' />
        <td className='kw-top-double text-right'>{Utils.convKingaku(goukei / katawakuSuuryou, 1)}</td>
        <td className='kw-top-double text-right'>{Utils.convKingaku(goukei)}</td>
        <td className='kw-top-double' />
      </tr>
    ) : []

    const uchiwakeList = list.slice(start, end).map((data, i) => {
      const kwDoubble = (i === 0) ? 'kw-top-double ' : ''
      const dataLength = end - start - 1
      const kwLast = (i === dataLength && list.length === end) ? 'kw-bottom-double ' : ''
      return (
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={'uchiwake' + category.code + 'List_' + tableOffset + '_' + i}>
          <td className={kwDoubble + kwLast} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='name' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-center'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='tani' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute={unitPriceName} isCommaSeparated isNum prefix='¥' decimalPlaces='1' textAlign='right' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(this.materiaKingaku(data, category))}</td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute={noteName} viewListId={viewListId} /></td>
        </tr>
      )
    })
    return (
      <div className='kw-detail' key={'uchiwake' + category.name + 'List_' + tableOffset}>
        {tableTitle}
        <table>
          <thead>
            <tr>
              <th className='kw-name' />
              <th className='kw-person' />
              <th className='kw-unit' />
              <th className='kw-yen-unit-price' />
              <th className='kw-yen1' />
              <th className='kw-note' />
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>名称</th>
              <th>数量</th>
              <th>単位</th>
              <th>単価</th>
              <th>金額</th>
              <th>備考</th>
            </tr>
            {uchiwakeList}
            {goukeiTr}
          </tbody>
        </table>
      </div>
    )
  }
  render () {
    const inputStyle = {
      backgroundColor: 'FFFFFF',
      cursor: 'normal'
    }
    var data = this.state.data.uchiwakeList
    let mokuzaiGoukei = 0
    let shoumouhinGoukei = 0
    let kousezaiGoukei = 0
    let katawakuSuuryou = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i].isKatawakuSuuryou) {
        katawakuSuuryou += Math.round(data[i].suuryou)
      }
      mokuzaiGoukei += Math.round(data[i].materialMokuzaiUnitPrice * data[i].suuryou)
      shoumouhinGoukei += Math.round(data[i].materialShoumouhinUnitPrice * data[i].suuryou)
      kousezaiGoukei += Math.round(data[i].materialKouseizaiUnitPrice * data[i].suuryou)
    }

    if (!this.state.data.materialCostDetailInputMode) {
      mokuzaiGoukei = this.state.data.materialMokuzaiUnitPrice * katawakuSuuryou
      shoumouhinGoukei = this.state.data.materialShoumouhinUnitPrice * katawakuSuuryou
      kousezaiGoukei = this.state.data.materialKouseizaiUnitPrice * katawakuSuuryou
    }

    const totalTable = (
      <table>
        <thead>
          <tr>
            <th className='kw-name' />
            <th className='kw-person' />
            <th className='kw-unit' />
            <th className='kw-yen-unit-price' />
            <th className='kw-yen1' />
            <th className='kw-note' />
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
            <th>備考</th>
          </tr>
          <tr>
            <td className='kw-top-double'>木材費</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-center'>㎡</td>
            <td className='kw-top-double text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
              ? Utils.convKingaku(mokuzaiGoukei / katawakuSuuryou, 1)
              : <OneLineEditor bindingDataAttribute='materialMokuzaiUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
            }
            </td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei)}</td>
            <td className='kw-top-double' style={inputStyle}><OneLineEditor bindingDataAttribute='materialMokuzaiNote' /></td>
          </tr>
          <tr>
            <td>消耗品費</td>
            <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='text-center'>㎡</td>
            <td className='text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
              ? Utils.convKingaku(shoumouhinGoukei / katawakuSuuryou, 1)
              : <OneLineEditor bindingDataAttribute='materialShoumouhinUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
            }
            </td>
            <td className='text-right'>{Utils.convKingaku(shoumouhinGoukei)}</td>
            <td style={inputStyle}><OneLineEditor bindingDataAttribute='materialShoumouhinNote' /></td>
          </tr>
          <tr>
            <td className='kw-bottom-double'>鋼製材損料</td>
            <td className='kw-bottom-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-bottom-double text-center'>㎡</td>
            <td className='kw-bottom-double text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
                                  ? Utils.convKingaku(kousezaiGoukei / katawakuSuuryou, 1)
                                  : <OneLineEditor bindingDataAttribute='materialKouseizaiUnitPrice' />
                                }</td>
            <td className='kw-bottom-double text-right'>
              {Utils.convKingaku(kousezaiGoukei)}
            </td>
            <td className='kw-bottom-double' style={inputStyle}><OneLineEditor bindingDataAttribute='materialKouseizaiNote' /></td>
          </tr>
          <tr>
            <td className='kw-top-double'>合計</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-top-double kw-ln' />
            <td className='kw-top-double text-right'>{Utils.convKingaku((mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei) / katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei)}</td>
            <td className='kw-top-double' />
          </tr>
        </tbody>
      </table>
    )

    const pages = []
    const dataList = this.state.data.uchiwakeList

    // 名称セル内で折り返される行数を概算する(材料費は名称列のみ折返しが発生し得る)。
    const estimateRowLines = (item) => {
      const NAME_CHARS_PER_LINE = 12
      const nameLen = (item.name || '').length
      return Math.max(1, Math.ceil(nameLen / NAME_CHARS_PER_LINE))
    }
    const dataLines = dataList.map(estimateRowLines)
    // [start, dataList.length) の範囲で行予算を超えない最大の end を返す。
    const findEndForLineBudget = (start, lineBudget) => {
      let lines = 0
      let end = start
      while (end < dataList.length) {
        const itemLines = dataLines[end]
        if (end > start && lines + itemLines > lineBudget) break
        lines += itemLines
        end++
      }
      return { end, lines }
    }

    // 行予算 (セル内折返し含む)。同じページに複数カテゴリを詰める。
    // 各カテゴリは renderDetailTable 内で見出し(start===0時)と小計(全項目印字時)が描画されるため、
    // 同ページに並んでも視覚的に区別される。
    // 行高 ≒ 8mm、A4内訳テーブル領域 ≒ 170mm を目安に行数を算出。
    const firstPageMokuzaiLineBudget = 18
    const pageLineBudget = 24

    // 材料費 1ページ目
    let printedMokuzaiDataCount = 0
    {
      const r = findEndForLineBudget(0, firstPageMokuzaiLineBudget)
      printedMokuzaiDataCount = r.end
    }
    const firstPageDetail = this.renderDetailTable(dataList, 0, printedMokuzaiDataCount, {code: 'Mokuzai', name: '木材費'}, 0, katawakuSuuryou, mokuzaiGoukei, dataList.length <= printedMokuzaiDataCount)
    const firstPage = (
      <div key='firstPage'>
        <article className='kw-katawaku-art'>
          <section className='kw-print-page'>
            <div className='kw-container'>
              <div className='kw-materialview'>
                <div className='kw-detail'>
                  <h5>材料費の計算</h5>
                  <p className='kw-pad1 kw-clear'>材料費計</p>
                  {totalTable}
                  {firstPageDetail}
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>
    )
    pages.push(firstPage)

    // 2ページ目以降
    let printedShoumouhinDataCount = 0
    let printedKouseizaiDataCount = 0
    let pageOffset = 0
    while (printedMokuzaiDataCount < dataList.length || printedShoumouhinDataCount < dataList.length || printedKouseizaiDataCount < dataList.length) {
      pageOffset++
      let remainingLineBudget = pageLineBudget
      const detailTable = []
      if (printedMokuzaiDataCount < dataList.length) {
        const r = findEndForLineBudget(printedMokuzaiDataCount, remainingLineBudget)
        const start = printedMokuzaiDataCount
        const end = r.end
        remainingLineBudget -= r.lines
        printedMokuzaiDataCount = end
        const detail = this.renderDetailTable(dataList, start, end, {code: 'Mokuzai', name: '木材費'}, pageOffset, katawakuSuuryou, mokuzaiGoukei, dataList.length === printedMokuzaiDataCount)
        detailTable.push(detail)
      }
      if (remainingLineBudget > 0 && printedShoumouhinDataCount < dataList.length) {
        const r = findEndForLineBudget(printedShoumouhinDataCount, remainingLineBudget)
        const start = printedShoumouhinDataCount
        const end = r.end
        remainingLineBudget -= r.lines
        printedShoumouhinDataCount = end
        const detail = this.renderDetailTable(dataList, start, end, {code: 'Shoumouhin', name: '消耗品費'}, pageOffset, katawakuSuuryou, shoumouhinGoukei, dataList.length === printedShoumouhinDataCount)
        detailTable.push(detail)
      }
      if (remainingLineBudget > 0 && printedKouseizaiDataCount < dataList.length) {
        const r = findEndForLineBudget(printedKouseizaiDataCount, remainingLineBudget)
        const start = printedKouseizaiDataCount
        const end = r.end
        remainingLineBudget -= r.lines
        printedKouseizaiDataCount = end
        const detail = this.renderDetailTable(dataList, start, end, {code: 'Kouseizai', name: '鋼製材損料'}, pageOffset, katawakuSuuryou, kousezaiGoukei, dataList.length === printedKouseizaiDataCount)
        detailTable.push(detail)
      }
      pages.push(
        <div key={pages.length}>
          <article className='kw-katawaku-art'>
            <section className='kw-print-page'>
              <div className='kw-container'>
                <div className='kw-materialview'>
                  <div className='kw-detail'>
                    {detailTable}
                  </div>
                </div>
              </div>
            </section>
          </article>
        </div>
      )
    }

    return pages
  }
}

export default MaterialCostPrintTab



// WEBPACK FOOTER //
// ./src/company_user/print/MaterialCostPrintTab.js